import { mapState, mapGetters, mapActions } from 'vuex'

// #region Auth
export const authComputed = {
  ...mapState('auth', {
    authDetails: state => state.authDetails,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])

// #endregion

// #region User
export const userComputed = {
  ...mapState('user', {
    currentUser: state => state.currentUser,
  }),
  ...mapGetters('user', [
    'getUser',
    'getSelectedOutlet',
    'getCurrentOutletData',
  ]),
}

export const userMethods = mapActions('user', [
  'fetchUser',

  'getUserByID',
  'setSelectedOutlet',
  'getAllUsersInDB',
])

// #endregion

// #region Comments
export const commentsComputed = {
  ...mapState('comments', {
    currentUser: state => state.currentUser,
  }),
  ...mapGetters('comments', ['getComment']),
}

export const commentsMethods = mapActions('comments', [
  'getComments',
  'saveComment',
  'updateComment',
])

// #endregion

// #region Item
export const itemComputed = {
  ...mapState('item', {
    items: state => state.items,
  }),
  ...mapGetters('item', [
    'getItems',
    'getGroupPriceUpdates',
    'getFoodDepartment',
  ]),
}

export const itemMethods = mapActions('item', [
  'fetchItems',
  'fetchItemsByGroup',
  'getModifierItems',
  'UpdateModiferItem',
  'UpdateItemUpdate',
  'getUpdateDocs',
  'insertCategory',
  'insertItem',
  'insertModiferItem',
  'insertModiferItemtoItemDoc',
  'updateModiferItem',
  'deleteModiferItem',
  'getPriceUpdates',
  'getFoodDepartmentbyID',
  'updateItem',
  'bulkPriceUpdateItems',
])

// #endregion

// #region user management
export const userManagementComputed = {
  ...mapState('userManagement', {
    modules: state => state.modules,
  }),
  ...mapGetters('userManagement', ['getModules', 'getGroupUserRoles']),
}

export const userManagementMethods = mapActions('userManagement', [
  'getAllModules',
  'saveUserRole',
  'getUserRoles',
  'getUsers',
  'saveUser',
  'deleteUserDocument',
  'deleteUserRoleDocument',
])
// #endregion

// #region report
export const reportComputed = {
  ...mapState('report', {
    reportData: state => state.reportData,
  }),
  ...mapGetters('report', ['getReportData', 'getReportInitialData']),
}

export const reportMethods = mapActions('report', [
  'fetchReport',
  'clearReportData',
  'setReportInitialData',
  'fetchOutletRelatedData',
  'setReportData',
])
//#endregion

//#region
export const dashMethods = mapActions('dashboard', ['fetchReport'])

//#endregion

// #region inventory
export const inventoryComputed = {
  // ...mapState('poList', {
  //   poListData: state => state.poListData,
  // }),
  // ...mapGetters('poList', ['getPoList']),
}

export const inventoryMethods = mapActions('inventory', [
  'getPoList',
  'getCategoryList',
  'getSubCategoryList',
  'getItemList',
  'getSupplierList',
  'getRestaurantList',
  'getTaxCombinationList',
  'getUnitList',
  'getPaymentModeList',
  'insertPo',
  'updatePo',
  'approvePo',
  'getPoCount',
  'getAllPOList',
  'getGrnList',
  'getGrnById',
  'insertGrn',
  'insertNewGrn',
  'updateGrn',
  'approveGrn',
  'getGrnByUUId',
  'getGrnCount',
  'getAllGrnList',
  'getStockAdjustmentList',
  'insertStockAdjustment',
  'getStockAdjustmentCount',
  'getAdjustmentTypeList',
  'insertNewStockAdjustment',
  'updateNewStockAdjustment',
  'approveNewStockAdjustment',
  'getAllStockAdjustmentList',
  'getStockEntryList',
  'insertStockEntry',
  'insertNewStockEntry',
  'updateNewStockEntry',
  'approveStockEntry',
  'getStockEntryCount',
  'getAllStockEntryList',
  'getWastageNoteList',
  'insertWastageNote',
  'insertNewWastageNote',
  'updateNewWastageNote',
  'approveWastageNote',
  'getWastageManagementCount',
  'getAvailableWastageStock',
  'getAllWastageList',
  'getMeasureTypeList',
  'insertMeasureType',
  'insertUnit',
  'getApprovedTransferOutList',
  'getPriorityLevelList',
  'getInventoryItemList',
  'getAllInventoryItemList',
  'getInvItemIngredeants',
  'insertInventoryItem',
  'getInventoryItemCount',
  'insertRecipe',
  'updateRecipe',
  'insertInvRecipe',
  'getRecipeList',
  'getInvRecipeList',
  'getTaxList',
  'getLogList',
  'insertLog',
  'getIssueNoteList',
  'insertIssueNote',
  'insertNewIssueNote',
  'updateIssueNote',
  'approveIssueNote',
  'getIssueNoteCount',
  'getSupplierReturnList',
  'insertSupplierReturn',
  'insertNewSupplierReturn',
  'updateNewSupplierReturn',
  'approveNewSupplierReturn',
  'getSupplierReturnCount',
  'getAllSRList',
  'insertStock',
  'getStockList',
  'insertCategory',
  'insertSubCategory',
  'insertSupplier',
  'updateSupplier',
  'insertTaxCombination',
  'insertTax',
  'updateTax',
  'updateTaxCombination',
  'insertBatchPRocess',
  'getBatchProcess',
  'runBatchProcess',
  'getAllIssueNoteList',
  'getAllStockList',
  'getTransferOutList',
  'getAllTransferOutList',
  'insertTransferOut',
  'insertNewTransferOut',
  'updateNewTransferOut',
  'approveNewTransferOut',
  'getTransferInList',
  'getAllTransferInList',
  'insertTransferIn',
  'insertNewTransferIn',
  'updateNewTransferIn',
  'approveNewTransferIn',
  'getTransferInCount',
  'getOutletTransferInList',
  'getNotificationLogList',
  'updateNotification',
  'getTransactionDoc',
  'getPoListDocs',
  'getByUid',
  'getGrnListDocs',
  'getGRNById',
  'getINListDocs',
  'getNoteById',
  'copyUOM',
  'copyCategory',
  'copySubCategory',
  'copyInvItems',
  'copySupplier',
  'copyRecipe',
  'copyInvRecipe',
  'getTransferOutListDocs',
  'getAllTransferOutListDocs',
  'getTransferInListDocs',
  'getInvReport',
  'insertNewSrn',
  'getAllSrn',
  'approveNewSRN',
  'getallSRN',
  'updateNewSRN',
  'getSrnListDocs',
  'getAllSrnListDocs',
  'getSAListDocs',
  'getSEListDocs',
  'getWSListDocs',
  'getSRListDocs',
  'getApprovedSRNList',
])
// #endregion

// #region discount

export const discountComputed = {
  ...mapState('discount', {
    discounts: state => state.discounts,
  }),
  ...mapGetters('discount', ['getDiscounts']),
}

export const discountMethods = mapActions('discount', [
  'fetchDiscounts',
  'insertDiscount',
  'updateDiscount',
  'deleteDiscountDocument',
])

// #endregion

// #region promotion
export const promotionComputed = {
  ...mapState('promotion', {
    promotion: state => state.promotion,
  }),
}

export const promotionMethods = mapActions('promotion', [
  'insertPromotion',
  'getPromotion',
  'setPromotion',
  'updatePromotion',
])

// #endregion

// #region cityLedger
export const cityLedgerMethods = mapActions('cityLedger', [
  'createCLCompany',
  'getCLCompanies',
  'createCLAccount',
  'setCLCompanies',
  'getCLAccounts',
  'updateCLAccount',
  'updateCLCompany',
  'getCLAccountsByCompany',
  'settleCityLedgerPayments',
  'settleCityLedgerAccountPayments',
])

export const cityLedgerComputed = {
  ...mapGetters('cityLedger', ['getCityLedgerCompanies']),
}
//#endregion

// #region SystemSettings
export const systemSettingsMethods = mapActions('systemSetting', [
  'getAllsystemSettings',
  'getOLOsystemSettings',
  'updateOLOsystemSettings',
  'setAllsystemSettings',
  'updatesystemSettings',
])

export const systemSettingsComputed = {
  ...mapGetters('systemSetting', ['getsystemSettings']),
}
// #endregion

// #region customPayment

export const customPaymentComputed = {
  ...mapState('customPayment', {
    discounts: state => state.customPayments,
  }),
  ...mapGetters('customPayment', ['getCustomPayments']),
}

export const customPaymentMethods = mapActions('customPayment', [
  'fetchCustomPaymentDocument',
  'insertCustomPaymentDocument',
  'updateCustomPaymentDocument',
])

// #endregion

// #region Charges
export const chargesMethods = mapActions('charges', [
  'getAllcharges',
  'setAllcharges',
  'updateCharges',
  'InsertCharges',
])

export const chargesComputed = {
  ...mapGetters('charges', ['getCharges']),
}
// #endregion

// #region Printer
export const printerMethods = mapActions('printer', [
  'createPrinters',
  'getAllPrinters',
  'setAllPrinters',
  'updatePrinters',
])

export const floorComputed = {
  ...mapGetters('printer', ['getFloor']),
}
// #endregion

// #region Floor
export const floorMethods = mapActions('floor', [
  'createFloors',
  'getAllFloors',
  'setAllFloors',
  'updateFloors',
])

export const printerComputed = {
  ...mapGetters('printer', ['getFloor']),
}
// #endregion

// #region Outlet
export const outletMethods = mapActions('outlet', [
  'createOutlets',
  'getAllOutlets',
  'setAllOutlets',
  'updateOutlets',
  'getGroup',
])

export const outletComputed = {
  ...mapGetters('outlet', ['getOutlet']),
}
// #endregion

// #region OLO Menu Items
export const oloMenuMethods = mapActions('oloMenuItem', [
  'fetchOLOItems',
  'insertItem',
  'updateOLOItem',
])

export const dashboardMethods = mapActions('dashboard', [
  'getRevenueDashData',
  'getReports',
  'insertDashboard',
])

// #endregion
